import styled from 'styled-components';
import { rgba } from 'polished';
import Icon from '../icon';

import {
	MenuLinkBtn,
	MenuLabel
} from '../main-menu/main-menu.css';

export const Container = styled.div`
	position: relative;
	z-index: 90;
`;

export const AvatarMenuLink = styled(MenuLinkBtn)`
	img {
		margin: 0.625rem 1rem;
		border-radius: 50%;
		width: 2rem;
		height: 2rem;
	}
`;

export const AvatarMenuLabel = styled(MenuLabel)`
	transform: translateX(-0.375rem);
`;

export const MenuContainer = styled.div`
	position: absolute;
	bottom: 0;
	left: 100%;
	transform: ${({ isActive }) => isActive ? 'scale(1)' : 'scale(0)' };
	transform-origin: bottom left;
	transition: transform 300ms cubic-bezier(0.455, 0.03, 0.515, 0.955),
		opacity 100ms ease-in-out,
		margin 300ms ease-in-out;
	opacity: ${({ isActive }) => isActive ? 1 : 0 };
	z-index: 92;
	margin: ${({ isActive }) => isActive ? '0.5rem' : '0' };
	border-radius: 0.25rem;
	box-shadow: 0 0.25rem 0.5rem ${({ theme }) => rgba(theme['black'], 0.25)};
	background: ${({ theme }) => theme['midnight-lighten-5']};
	padding: 1rem;
	min-width: 21rem;
`;

export const UserName = styled.h6`
	margin: 0;
	font-weight: 700;
`;

export const UserEmail = styled.p`
	margin: 0;
	font-size: 0.9rem;
`;

export const AvatarActions = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	margin-top: 1rem;
`;

export const AvatarButtons = styled.div`
	button {
		&:not(:last-child) {
			margin-right: 0.5rem;
		}
	}
`;

export const PreferencesButton = styled(Icon)`
	opacity: 0.5;
	transition: opacity 150ms ease-out;
	cursor: pointer;

	&:hover {
		opacity: 1;
	}
`;

export const AvatarOverlay = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: ${({ isMaximized }) => isMaximized ? '12rem' : '4rem' };
	transition: opacity 300ms ease-in-out;
	opacity: ${({ isActive }) => isActive ? 1 : 0 };
	z-index: 91;
	background-color: ${({ theme }) => rgba(theme['black'], 0.5)};
	pointer-events: ${({ isActive }) => isActive ? 'all' : 'none' };
`;
